import * as moment from 'moment';
import { config } from '../../config';

export default function filterOverDue(dueDate: string, isSalesLedger=false): boolean{
    if(isSalesLedger){
        dueDate = moment(dueDate).format(config.cmsDateFormat)
    }else{
        dueDate = moment(dueDate).format(config.dueDateFormat);
    }
    return moment(dueDate).isBefore(moment(), 'day');
}